import { booleanDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default booleanDuckCreator({
    ...srpDuckPreset,
    store: 'sponsorship',
});
